import styled, { css } from 'styled-components';
import { MergeElementProps } from '@amzn/storm-ui-utils';
import isMobile from '../theme/style-mixins/isMobile/isMobile';
import { InputFormGroupTheme } from './types';

function selectRadius({ theme }: { theme: InputFormGroupTheme }) {
  return theme.form.input.radius;
}

export interface SuffixProps extends MergeElementProps<'div'> {
  disabled?: boolean;
  $ignoreTextDirection?: boolean;
}

const Suffix = styled('div')<SuffixProps>`
  flex: 0 0 auto;
  box-sizing: border-box;
  white-space: nowrap;
  display: flex;
  align-items: center;
  padding-inline-start: ${({ theme }) => theme.spacing.small};
  padding-inline-end: calc(${({ theme }) => theme.spacing.small} - 2px);
  min-height: calc(${({ theme }) => theme.form.input.height} - 6px);
  background: ${({ theme }) => theme.form.input.affix.bg};
  font-size: ${({ theme }) => theme.form.input.affix.fontSize};
  color: ${({ theme }) => theme.form.input.affix.color};
  line-height: 1.465;

  /*! @noflip */ border-radius: 0 ${selectRadius} ${selectRadius} 0;

  ${({ $ignoreTextDirection }) => (!$ignoreTextDirection && css`
    /*! @noflip */
    [dir="rtl"] && {
      /*! @noflip */ border-radius: ${selectRadius} 0 0 ${selectRadius};
    }
  `)}

  ${({ disabled, theme }) => (disabled && css`
    cursor: not-allowed;
    outline: none;
    opacity: 1;
    border-color: ${theme.form.input.disabled.borderColor};
    background: ${theme.form.input.disabled.bg};
    color: ${theme.form.input.disabled.color};
  `)}

  ${isMobile(css`
    padding-inline-start: ${({ theme }) => theme.mobile.spacing.mini};
    padding-inline-end: calc(${({ theme }) => theme.mobile.spacing.mini} - 2px);
    font-size: ${({ theme }) => theme.form.input.mobile.affix.fontSize};
  `)}
`;
Suffix.displayName = 'Suffix';

export default Suffix;
